import React, { useEffect, useState } from "react";
import "../noreba.css";

function Normas() {
    const [lista, setLista] = useState([]);
    const [error, setError] = useState("");

    const cargarLista = async () => {
        try {
            const r = await fetch("/api/normas");
            if (!r.ok) throw new Error(await r.text());
            const data = await r.json();
            setLista(Array.isArray(data) ? data : []);
        } catch (e) {
            setError("No se pudieron cargar los documentos");
        }
    };

    useEffect(() => {
        cargarLista();
    }, []);

    const formatFecha = (v) => {
        if (!v) return "";
        const d = new Date(v);
        return isNaN(d) ? v : d.toLocaleDateString("es-ES");
    };

    const descargar = async (item) => {
        try {
            const r = await fetch(`/api/normas/${item._id}?download=1`);
            if (!r.ok) throw new Error("Error al descargar el archivo");
            const blob = await r.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            // ✅ prioridad: metadata.nombre > nombre > alias > filename
            a.download = (item.metadata?.nombre || item.nombre || item.alias || item.filename || "documento") + ".pdf";
            a.click();
            a.remove();
        } catch {
            setError("No se pudo descargar el archivo");
        }
    };

    return (
        <div className="noreba-wrap">
            <header className="noreba-header">
                <h1>Normas de Asistencia</h1>
            </header>

            {error && <div className="noreba-error">{error}</div>}

            <section className="noreba-list">
                {lista.length === 0 && (
                    <div className="noreba-empty">No hay documentos disponibles</div>
                )}

                {lista.map((it) => (
                    <article key={it._id} className="noreba-item">
                        <div className="info">
                            {/* ✅ mostramos metadata.nombre como principal */}
                            <div className="title">{it.metadata?.nombre || it.nombre || it.alias || it.filename}</div>
                            <div className="meta">
                                <span>{(it.length / 1024).toFixed(1)} KB</span>
                                <span> • </span>
                                <span>{formatFecha(it.uploadDate)}</span>
                            </div>
                        </div>
                        <div className="actions">
                            <button className="btn-view" onClick={() => descargar(it)}>
                                Descargar
                            </button>
                        </div>
                    </article>
                ))}
            </section>
        </div>
    );
}

export default Normas;
